var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { reqNewGetSpecialPageByCon } from "../request/designapi/design/salesRendering/newGetSpecialPageByCon/post.js";
async function checkRelationOrder(arg) {
  const { relationOrderParanms, checkParams } = arg;
  const relationOrder = await reqNewGetSpecialPageByCon(__spreadProps(__spreadValues({}, relationOrderParanms), {
    pageSize: 500
  }));
  const relationOrderList = relationOrder.records;
  return relationOrderList.some((r) => {
    let ret = true;
    if (checkParams.orgNo) {
      ret = ret && r.orgNo === checkParams.orgNo;
    }
    if (checkParams.rosterValue) {
      ret = ret && (r.rosterValue === checkParams.rosterValue || r.rosterValue === "ALL");
    }
    return ret;
  });
}
export { checkRelationOrder };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/utils/checkRelationOrder.js